import { type ReactNode } from 'react';

import LoadingOverlay from '@achmadk/react-loading-overlay';
import { type TaxReturnFormLoadingState } from '@dec/shared';

interface Props {
  children: ReactNode;
  loading: TaxReturnFormLoadingState;
}

export const FormLoadingOverlay = ({ children, loading }: Props) => (
  <LoadingOverlay active={loading.active} spinner text={loading.title}>
    {children}
  </LoadingOverlay>
);
